























import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import iwModal from "@/shared/components/Modal.vue";
import iwMasqueradeExtension from "@/myImmoweb/modal/MasqueradeExtension.vue";
import iwMasqueradeReactivate from "@/myImmoweb/modal/MasqueradeReactivate.vue";
import iwMasqueradeActivate from "@/myImmoweb/modal/MasqueradeActivate.vue";
import iwMasqueradeUpgrade from "@/myImmoweb/modal/MasqueradeUpgrade.vue";

export default Vue.extend({
    components: {
        iwModal: iwModal,
        iwMasqueradeExtension: iwMasqueradeExtension,
        iwMasqueradeReactivate: iwMasqueradeReactivate,
        iwMasqueradeActivate: iwMasqueradeActivate,
        iwMasqueradeUpgrade: iwMasqueradeUpgrade,
    },

    computed: {
        ...mapGetters({
            modalTitle: "ModalModule/getModalTitle",
            isMasqueradeModalOpen: "ModalModule/isMasqueradeModalOpen"
        }),
    },

    methods: {
        ...mapActions({
            closeMasqueradeModal: "ModalModule/closeMasqueradeModal"
        }),

        onSuccess: function(): void {
            this.$emit("success");
            this.closeMasqueradeModal();
        }
    },
});

